import {
  DESTROY_BACKDROP,
  FETCH_ALL_CMOS,
  FETCH_ALL_INVENTORY_DATA,
  FETCH_ALL_INVENTORY_DATA_LOADING,
  FETCH_ALL_LOT_NUMBERS,
  FETCH_ALL_PLANT_CODES,
  FETCH_ALL_RMPM_CODES,
  INVENTORY_STATUS_SAVE_FILTERS,
  OPEN_BACKDROP, FETCH_ALL_RECEIVING_PLANT_IDS_REQUEST,
  FETCH_ALL_RECEIVING_PLANT_IDS_SUCCESS,
  FETCH_ALL_RECEIVING_PLANT_IDS_FAIL,
  FETCH_ALL_STORAGE_LOCATION_IDS,
  FETCH_MATERIAL_TYPES,
} from "../../actions/types";

const initialState = {};

const inventoryStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_INVENTORY_DATA:
      return {
        ...state,
        inventoryStatusDetails: action.payload, // Update the state with the fetched data
      };
    case FETCH_ALL_INVENTORY_DATA_LOADING:
      return {
        ...state,
        inventoryStatusDetailsLoading: action.payload, // Update the state with the fetched data
      };
    case FETCH_ALL_CMOS:
      return {
        ...state,
        cmosDetails: action.payload, // Update the state with the fetched data
      };
      case FETCH_ALL_RECEIVING_PLANT_IDS_REQUEST:
      return {
        ...state,
        plantCodeDetails: {
          ...state.plantCodeDetails,
          loading: true,
          error: null,
        },
      };
    case FETCH_ALL_RECEIVING_PLANT_IDS_SUCCESS:
      return {
        ...state,
        plantCodeDetails: {
          data: action.payload.data,
          loading: false,
          error: null,
        },
      };
    case FETCH_ALL_RECEIVING_PLANT_IDS_FAIL:
      return {
        ...state,
        plantCodeDetails: {
          data: [],
          loading: false,
          error: action.payload,
        },
      };
    case FETCH_ALL_STORAGE_LOCATION_IDS:
      return {
        ...state,
        storageLocationDetails: {
          data: action.payload.data,
          loading: false,
          error: action.payload.error === "" ? null : action.payload.error,
        },
      };
    case FETCH_ALL_PLANT_CODES:
      return {
        ...state,
        plantCodeDetails: action.payload, // Update the state with the fetched data
      };
    case FETCH_ALL_RMPM_CODES:
      return {
        ...state,
        materialCodesDetails: action.payload, // Update the state with the fetched data
      };
    case FETCH_ALL_LOT_NUMBERS:
      return {
        ...state,
        lotNumberDetails: action.payload, // Update the state with the fetched data
      };
    case FETCH_MATERIAL_TYPES:
      return {
        ...state,
        materialTypesDetails: action.payload,
      };
    case INVENTORY_STATUS_SAVE_FILTERS:
      return {
        ...state,
        inventoryStatusSaveDetails: action.payload, // Update the state with the fetched data
      };
    case OPEN_BACKDROP:
      return {
        ...state,
        backdropLoading: true,
        backdropText: action.backdropText
          ? action.backdropText
          : `Please don't refresh or close the tab while processing`,
      };

    case DESTROY_BACKDROP:
      return {
        ...state,
        backdropLoading: false,
      };
    default:
      return state;
  }
};

export default inventoryStatusReducer;
